/**
 * @file
 * Swiper slider.
 *
 */
(function(Drupal, once) {
  'use strict';
  Drupal.behaviors.swiperSlideShow = {
    attach: function(context, settings) {
      const progressCircle = document.querySelector(".autoplay-progress svg");
      const progressContent = document.querySelector(".autoplay-progress span");

      let swiperSlideShow = new Swiper(".swiper-slide-show", {
        spaceBetween: 0,
        loop: true,
        centeredSlides: true,
        autoplay: {
          delay: 7000,
          disableOnInteraction: false
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        on: {
          autoplayTimeLeft(s, time, progress) {
            progressCircle.style.setProperty("--progress", 1 - progress);
            progressContent.textContent = `${Math.ceil(time / 1000)}`;
          }
        }
      });
    }
  };

})(Drupal, once);
